// src/_helpers/slugify.js

/**
 * Generate URL-friendly slug from text.
 * Supports English and keeps Farsi/Arabic characters.
 * Falls back to timestamp if result is empty.
 */
const slugify = (text) => {
  if (!text) return `post-${Date.now()}`;

  let slug = text
    .toString()
    .trim()
    .toLowerCase()
    // Replace spaces and underscores with hyphens
    .replace(/[\s_]+/g, "-")
    // Remove special characters (keep letters, numbers, hyphens, and Unicode chars)
    .replace(/[^\w\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF-]+/g, "")
    // Remove multiple consecutive hyphens
    .replace(/-{2,}/g, "-")
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, "");

  // If slug is empty after processing, use timestamp
  if (!slug) {
    slug = `post-${Date.now()}`;
  }

  return slug;
};

export default slugify;
